'use client';

import { AnchorButton, anchorButtonTag } from '@ni/nimble-components/dist/esm/anchor-button';
import { wrap } from '../utilities/react-wrapper';

export { anchorButtonTag };
export { type AnchorButton };
export const NimbleAnchorButton = wrap(AnchorButton);
